export default __webpack_public_path__ + "static/gs-python-code--mobile-5229fcad603d7250cd02293d2de6a7b3.png";